// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_rpn5x {
  padding: 10px 26px 10px 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid #F4F6FA;
}

.headerRow_ynr2Q {
  width: 100%;
}

.label_EBSr9 {
  width: 60px;
}

.itemName_gur_t {
  width: 100%;
  margin-bottom: var(--size-padSmall, 4px);
}

.apiKey_EhjdP,
.secret_kLe8x,
.resource_c8Ijf {
  flex: 1;
  text-overflow: ellipsis;
  padding: 0 10px;
  color: var(--light-grey);
  width: 100%;
}

.apiAccessItemArea_TaYX9 {
  align-items: flex-start !important;
}

.apiAccessContent_R25j3>* {
  margin-top: 8px;
}

.apiAccessItem_JF2fw:hover {
  background: white;
}

.content_LCs2r {
  padding: 0 0;

  .addApiAccess_RSuQG {
    margin-bottom: 10px;
    align-self: left;
    align-items: flex-start;
  }

  .apiAccessHeader_RJgEn {
    border-top: 5px solid var(--background);
    border-bottom: 5px solid var(--background);
    padding: 10px 26px 10px 10px;
  }

  .settingsHeader_LouX5 {
    border-bottom: 5px solid var(--background);
    padding: 10px 26px 10px 10px;

  }

  .apiAccessItem_JF2fw+.apiAccessItem_JF2fw {
    border-top: 1px solid var(--lighter-grey);
  }

  .apiAccessItem_JF2fw:hover {
    background: white;
  }

  .apiAccessContent_R25j3 {
    padding-left: 0px;
  }

  .apiKeyItem_hqT3q,
  .secretItem_c9Leq {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;


    label {
      margin: 0;
      width: 50px;
    }
  }

  .apiAccessDisabled_Pf6Hx:hover,
  .apiAccessDisabled_Pf6Hx:active,
  .apiAccessDisabled_Pf6Hx:focus,
  .apiAccessDisabled_Pf6Hx:focus:hover,
  .apiAccessDisabled_Pf6Hx:focus:active .apiAccessEnabled_sr4UH:hover,
  .apiAccessEnabled_sr4UH:active,
  .apiAccessEnabled_sr4UH:focus,
  .apiAccessEnabled_sr4UH:focus:hover,
  .apiAccessEnabled_sr4UH:focus:active {
    outline: none;
  }

  .apiAccessEnabled_sr4UH:active,
  .apiAccessDisabled_Pf6Hx:active {
    background: var(--lighter-grey);
  }

  .apiAccessDisabled_Pf6Hx {
    color: var(--light-grey) !important;
  }

  .apiAccessEnabled_sr4UH {
    color: var(--green) !important;
  }

}

.optionsMenu_QeUIr {
  margin-left: auto;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0);
}

.optionsMenu_QeUIr.popupOpen_z6j_6 {
  background-color: var(--light-grey);

  .option_lr6SP {
    background-color: white;
    color: black;
  }

  .option_lr6SP:hover {
    text-decoration: none;
    background-color: var(--lighter-grey);
  }
}

.optionsMenu_QeUIr.popupOpen_z6j_6:hover {
  background-color: var(--light-grey);
}`, "",{"version":3,"sources":["webpack://./src/screens/apiAccess/apiAccess.css"],"names":[],"mappings":"AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;;EAGE,OAAO;EACP,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;;EAEZ;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,uCAAuC;IACvC,0CAA0C;IAC1C,4BAA4B;EAC9B;;EAEA;IACE,0CAA0C;IAC1C,4BAA4B;;EAE9B;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;;;IAGX;MACE,SAAS;MACT,WAAW;IACb;EACF;;EAEA;;;;;;;;;IASE,aAAa;EACf;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,8BAA8B;EAChC;;AAEF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;;EAEnC;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,qCAAqC;EACvC;AACF;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["@import \"../../style/theme.css\";\n\n.header {\n  padding: 10px 26px 10px 20px;\n  text-align: right;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 5px solid #F4F6FA;\n}\n\n.headerRow {\n  width: 100%;\n}\n\n.label {\n  width: 60px;\n}\n\n.itemName {\n  width: 100%;\n  margin-bottom: var(--size-padSmall, 4px);\n}\n\n.apiKey,\n.secret,\n.resource {\n  flex: 1;\n  text-overflow: ellipsis;\n  padding: 0 10px;\n  color: var(--light-grey);\n  width: 100%;\n}\n\n.apiAccessItemArea {\n  align-items: flex-start !important;\n}\n\n.apiAccessContent>* {\n  margin-top: 8px;\n}\n\n.apiAccessItem:hover {\n  background: white;\n}\n\n.content {\n  padding: 0 0;\n\n  .addApiAccess {\n    margin-bottom: 10px;\n    align-self: left;\n    align-items: flex-start;\n  }\n\n  .apiAccessHeader {\n    border-top: 5px solid var(--background);\n    border-bottom: 5px solid var(--background);\n    padding: 10px 26px 10px 10px;\n  }\n\n  .settingsHeader {\n    border-bottom: 5px solid var(--background);\n    padding: 10px 26px 10px 10px;\n\n  }\n\n  .apiAccessItem+.apiAccessItem {\n    border-top: 1px solid var(--lighter-grey);\n  }\n\n  .apiAccessItem:hover {\n    background: white;\n  }\n\n  .apiAccessContent {\n    padding-left: 0px;\n  }\n\n  .apiKeyItem,\n  .secretItem {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n\n\n    label {\n      margin: 0;\n      width: 50px;\n    }\n  }\n\n  .apiAccessDisabled:hover,\n  .apiAccessDisabled:active,\n  .apiAccessDisabled:focus,\n  .apiAccessDisabled:focus:hover,\n  .apiAccessDisabled:focus:active .apiAccessEnabled:hover,\n  .apiAccessEnabled:active,\n  .apiAccessEnabled:focus,\n  .apiAccessEnabled:focus:hover,\n  .apiAccessEnabled:focus:active {\n    outline: none;\n  }\n\n  .apiAccessEnabled:active,\n  .apiAccessDisabled:active {\n    background: var(--lighter-grey);\n  }\n\n  .apiAccessDisabled {\n    color: var(--light-grey) !important;\n  }\n\n  .apiAccessEnabled {\n    color: var(--green) !important;\n  }\n\n}\n\n.optionsMenu {\n  margin-left: auto;\n  font-size: 16px;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.optionsMenu.popupOpen {\n  background-color: var(--light-grey);\n\n  .option {\n    background-color: white;\n    color: black;\n  }\n\n  .option:hover {\n    text-decoration: none;\n    background-color: var(--lighter-grey);\n  }\n}\n\n.optionsMenu.popupOpen:hover {\n  background-color: var(--light-grey);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_rpn5x`,
	"headerRow": `headerRow_ynr2Q`,
	"label": `label_EBSr9`,
	"itemName": `itemName_gur_t`,
	"apiKey": `apiKey_EhjdP`,
	"secret": `secret_kLe8x`,
	"resource": `resource_c8Ijf`,
	"apiAccessItemArea": `apiAccessItemArea_TaYX9`,
	"apiAccessContent": `apiAccessContent_R25j3`,
	"apiAccessItem": `apiAccessItem_JF2fw`,
	"content": `content_LCs2r`,
	"addApiAccess": `addApiAccess_RSuQG`,
	"apiAccessHeader": `apiAccessHeader_RJgEn`,
	"settingsHeader": `settingsHeader_LouX5`,
	"apiKeyItem": `apiKeyItem_hqT3q`,
	"secretItem": `secretItem_c9Leq`,
	"apiAccessDisabled": `apiAccessDisabled_Pf6Hx`,
	"apiAccessEnabled": `apiAccessEnabled_sr4UH`,
	"optionsMenu": `optionsMenu_QeUIr`,
	"popupOpen": `popupOpen_z6j_6`,
	"option": `option_lr6SP`
};
export default ___CSS_LOADER_EXPORT___;
